import React from 'react'
import SidebarClient from '@/components/Sidebar/Sidebar/SidebarClient'

const Sidebar = ({ id, children }: { id: string; children: React.ReactNode }) => {
  return <SidebarClient id={id}>{children}</SidebarClient>
}

export default Sidebar
